const config = {
  default: {
    namespace: 'App'
  },
  // baseUrl: 'http://localhost:3008/api/v1'
  baseUrl: 'https://notify.arachnomesh.com/api/v1'
}

export default config;